import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import "dayjs/locale/pt-br";

export const APP_TIMEZONE = "America/Sao_Paulo";
export const APP_LOCALE = "pt-BR";

let dayjsTimezoneConfigured = false;

export const setupAppTimezone = () => {
  if (!dayjsTimezoneConfigured) {
    dayjs.extend(utc);
    dayjs.extend(timezone);
    dayjs.locale("pt-br");
    dayjs.tz.setDefault(APP_TIMEZONE);
    dayjsTimezoneConfigured = true;
  }
};

const buildFormatter = (options: Intl.DateTimeFormatOptions) => {
  return new Intl.DateTimeFormat(APP_LOCALE, {
    timeZone: APP_TIMEZONE,
    ...options,
  });
};

export const getDateInAppTimezone = (value: Date | string | number) => {
  const date = value instanceof Date ? value : new Date(value);

  if (Number.isNaN(date.getTime())) {
    return null;
  }

  return date;
};

export const formatDateInAppTimezone = (
  value: Date | string | number | null | undefined,
  options: Intl.DateTimeFormatOptions,
) => {
  if (value === null || value === undefined || value === "") {
    return "";
  }

  const date = getDateInAppTimezone(value);

  if (!date) {
    return "";
  }

  return buildFormatter(options).format(date);
};

export const formatDatePartsInAppTimezone = (value: Date | string | number) => {
  const date = getDateInAppTimezone(value);

  if (!date) {
    return null;
  }

  const parts = buildFormatter({
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(date);

  const getPart = (type: Intl.DateTimeFormatPartTypes) =>
    parts.find((part) => part.type === type)?.value || "";

  return {
    year: getPart("year"),
    month: getPart("month"),
    day: getPart("day"),
  };
};
